import { MarketTimeframes } from '@/modules/market-closed/types/market-closed';

// ORM actions
export enum RestOperation {
  Noop = 0,
  Create,
  Read,
  Update,
  Delete,
}

// for the backend: buy=bid=loan; sell=ask=borrow
export enum Direction {
  Lend = 'lend',
  Borrow = 'borrow',
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const OrderType = {
  Limit: 'LIMIT',
  Market: 'MARKET',
} as const;
export type OrderType = (typeof OrderType)[keyof typeof OrderType];

// REST buffers
export interface ClientConfig {
  systemTitleShort: string;
  systemTitleLong: string;
  systemBrokerName: string;
  systemBrokerFullName: string;
  systemBrokerLegalName: string;
  systemBrokerSiteURL: string;
  systemBrokerContactEmail: string;
  systemProdLike: boolean;
  systemEnv: 'prod' | 'uat' | 'sandbox' | 'review' | 'demo' | 'test' | 'dev' | 'playground';
  systemRelease: string;
  systemRootURL: string;
  frontendHash: string;
  clientIpAddress: string;
  timezone: string;
  timezoneLabel: string;
  timezoneOffset: string;
  tfaResetByEmail: boolean;
  maxRate: number;
  sentryServerDSN: string;
  sentryEnvironment: string;
  demoMode: boolean;
  suppressGridVirtualisation: boolean;

  /**
   * Enables/disabled the use of market timeframes to allow interaction with various features
   */
  marketTimeframesEnabled: boolean;
  marketTimeframes: MarketTimeframes;
  omsAllowMarketOrders: boolean;
  currentTimeUTC: Date;
  holidaysLast24Months: string[]; // yyyy-MM-dd

  // feature flags
  createLoansEnabled: boolean;
  varCalcEnabled: boolean;
  orderbookCounterpartyChoiceEnabled: boolean;
  orderbookSettlementTypeChoiceEnabled: boolean;
  orderbookMinQuantityEditable: boolean;
  seclendingAnalyticsEnabled: boolean;
  termLoansEnabled: boolean;
  finraTransactionsEnabled: boolean;
  corpActionsEnabled: boolean;
  nsccDashboardEnabled: boolean;
  bilateralLoansEnabled: boolean;
  occBilateralLoansEnabled: boolean;
  marketplaceExplorerEnabled: boolean;
  marketplaceTopOfBookEnabled: boolean;
  orderbookSplitOrdersEnabled: boolean;

  autoDisableInactiveDaysMin: number;
}

export interface UXConfig {
  // when forceMarketTimeframesCheckingEvenWhenDisabled is true we will enforce timeframes,
  //  even when they're disabled (for this env)
  forceMarketTimeframesCheckingEvenWhenDisabled: boolean;
  // when forceMarketTimeframesClosed is true we will pretend all timeframes are closed
  //  (so all timeframe dependant features will be disabled)
  forceMarketTimeframesClosed: boolean;
  dismissedPreEstablishedInfo: boolean;
}

export interface LoginSalt {
  salt: string;
}

export interface LoginPreparePasswordResponse {
  email: string;
  freshAccount: boolean;
}

export interface User2FASettings {
  id: string;
  tfaIsEnabled: boolean;
  tfaIssuer: string;
  tfaIssuerName: string;
  tfaIssuerSecret: string;
}

export interface RfcRequest {
  rfcText: string;
  rfcPath: string;
  rfcPage: string;
}

export interface TradingPermissionOption {
  permission: number | null; // null = inherit from company
}

export interface InvestorProfile {
  id: string;
  label: string;
}
